/* Pistacho — Mix and Match: montar o conjunto de uma divisao.

   A divisao escolhe os grupos (a peca principal e as que a completam). Em
   cada grupo escolhe-se uma peca pelo cartao; a peca abre as versoes e as
   opcoes dela, lidas de /products/<handle>.js so nessa altura. As opcoes das
   pecas que completam partem do acabamento da principal (Madeira Carvalho na
   cama, Madeira Carvalho na mesa) enquanto o cliente nao lhes mexer — a mesma
   regra do «Em pack» da ficha nova.

   As contas sao as do carrinho: assets/packs-contas.js repete as regras da
   Function pack-discounts. O botao leva tudo de uma vez pelo /cart/add.js; o
   desconto aplica-o o carrinho sozinho.

   Endereco directo: ?divisao=sala&peca=sofa-hug-3-lugares abre com a divisao
   e a peca escolhidas (e o que a ficha nova usa em «Montar o conjunto»).
*/
(function () {
  'use strict';

  var raiz = document.querySelector('[data-mm]');
  if (!raiz || !window.PistachoPacks) return;
  var packsDe = window.PistachoPacks.packsDe;
  var moeda = window.PistachoPacks.moeda;
  // As frases vem dos locales (bloco data-mm-t da seccao, na lingua da pagina).
  var T = {};
  try { T = JSON.parse(raiz.querySelector('[data-mm-t]').textContent) || {}; } catch (e) { T = {}; }
  function tr(k, v) {
    var s = T[k] || '';
    if (v) Object.keys(v).forEach(function (n) { s = s.split('{' + n + '}').join(v[n]); });
    return s;
  }

  var SEP = '\u001f';
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function img(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 400);
  }
  var raizLoja = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---- os produtos, lidos quando se escolhem --------------------------- */

  var cache = {};
  function carregar(h) {
    if (!cache[h]) {
      cache[h] = fetch(raizLoja + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (p) {
          return {
            h: p.handle,
            t: p.title,
            opcoes: (p.options || []).map(function (o) { return { nome: o.name, valores: o.values }; }),
            v: p.variants.map(function (v) {
              return { id: v.id, o: v.options, c: v.price, ok: v.available, img: v.featured_image ? v.featured_image.src : null };
            }),
            img: p.featured_image
          };
        })
        .catch(function (e) { delete cache[h]; throw e; });
    }
    return cache[h];
  }
  function varDe(p, vals) {
    var k = vals.join(SEP);
    for (var i = 0; i < p.v.length; i++) if (p.v[i].o.join(SEP) === k) return p.v[i];
    return null;
  }
  function disponiveis(p) { return p.v.filter(function (v) { return v.ok; }); }
  // Os valores de partida: os que a peca principal ja tem, senao os da
  // primeira variante disponivel. Se a combinacao nao existe, a mais parecida.
  function iniciais(p, seguir) {
    var prim = disponiveis(p)[0] || p.v[0];
    var vals = p.opcoes.map(function (o, i) {
      for (var j = 0; j < o.valores.length; j++) if (seguir && seguir.indexOf(o.valores[j]) > -1) return o.valores[j];
      return prim.o[i];
    });
    return perto(p, vals, -1);
  }
  // A variante disponivel mais parecida com `vals`, obrigada ao eixo `fixo`.
  function perto(p, vals, fixo) {
    var v = varDe(p, vals);
    if (v && v.ok) return vals.slice();
    var melhor = null, pts = -1;
    disponiveis(p).forEach(function (x) {
      if (fixo > -1 && x.o[fixo] !== vals[fixo]) return;
      var n = 0;
      x.o.forEach(function (val, i) { if (val === vals[i]) n++; });
      if (n > pts) { pts = n; melhor = x; }
    });
    return melhor ? melhor.o.slice() : vals.slice();
  }

  /* ---- o estado ---------------------------------------------------------- */

  var salaActual = null;
  var grupos = [];   // os da divisao actual: { el, cat, q, papel, um, esc }
  // esc: { op (handle do cartao), h (handle da versao), p (produto), vals, mexeu }
  var estados = {};  // por divisao, para voltar a uma sem perder o que se escolheu

  function lerGrupos(sala) {
    var bloco = raiz.querySelector('[data-mm-sala="' + sala + '"]');
    return Array.prototype.map.call(bloco.querySelectorAll('[data-mm-grupo]'), function (el) {
      return {
        el: el,
        cat: el.getAttribute('data-cat'),
        q: +el.getAttribute('data-q') || 1,
        papel: el.getAttribute('data-papel'),
        um: el.getAttribute('data-um'),
        medida: el.hasAttribute('data-medida'),
        esc: null
      };
    });
  }
  function ancora() { return grupos.filter(function (g) { return g.papel === 'ancora'; })[0]; }
  // O estrado e o colchao vao na medida da cama: "QUEEN SIZE (1600X2000)" ->
  // 1600, e escolhe-se a variante deles que a tem ("1600x2000").
  function medida() {
    var a = ancora(), v = a && a.esc && a.esc.p ? varDe(a.esc.p, a.esc.vals) : null;
    var m = v && /1[4-9]\d0/.exec(v.o.join(' '));
    return m ? m[0] : '';
  }
  // O estrado elevatorio so serve o sommier.
  function eSommier() { var a = ancora(); return !!(a && a.esc && /sommier/i.test(a.esc.h)); }
  function varDoGrupo(g) {
    if (!g.esc || !g.esc.p) return null;
    if (g.medida) {
      var m = medida();
      if (!m) return null;
      for (var i = 0; i < g.esc.p.v.length; i++) if (g.esc.p.v[i].ok && g.esc.p.v[i].o.join(' ').indexOf(m) > -1) return g.esc.p.v[i];
      return null;
    }
    return varDe(g.esc.p, g.esc.vals);
  }
  function versoesDe(bt) {
    var vs = [];
    try { vs = JSON.parse(bt.getAttribute('data-versoes') || '[]'); } catch (e) { vs = []; }
    return vs.filter(function (x) { return x.h; });
  }
  function cartao(g, h) { return g.el.querySelector('[data-mm-op][data-h="' + h + '"]'); }

  function mudarSala(sala) {
    if (salaActual === sala) return;
    if (salaActual) estados[salaActual] = grupos;
    salaActual = sala;
    raiz.querySelectorAll('[data-mm-sala-bt]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-mm-sala-bt') === sala ? 'true' : 'false');
    });
    raiz.querySelectorAll('[data-mm-sala]').forEach(function (b) { b.hidden = b.getAttribute('data-mm-sala') !== sala; });
    grupos = estados[sala] || lerGrupos(sala);
    pintarTudo();
  }

  // Escolher (ou trocar de versao de) uma peca num grupo.
  function escolher(g, op, h) {
    var anterior = g.esc;
    var tok = {};
    g.esc = { op: op, h: h, p: null, vals: null, mexeu: anterior && anterior.op === op ? anterior.mexeu : false, tok: tok };
    pintarGrupo(g);
    pintarResumo();
    carregar(h).then(function (p) {
      if (!g.esc || g.esc.tok !== tok) return;
      var seguir;
      if (anterior && anterior.op === op && anterior.vals && anterior.p) {
        // trocar de versao guarda o que ja estava escolhido, pelo nome do eixo
        seguir = anterior.vals;
      } else if (g.papel !== 'ancora') {
        var va = varDoGrupo(ancora());
        seguir = va ? va.o : null;
      }
      g.esc.p = p;
      g.esc.vals = iniciais(p, seguir);
      // a divisao pode ter mudado entretanto: guarda-se, pinta-se quando voltar
      if (grupos.indexOf(g) < 0) return;
      pintarGrupo(g);
      if (g.papel === 'ancora') seguirAncora();
      pintarResumo();
    }).catch(function () {
      if (g.esc && g.esc.tok === tok) {
        g.esc = null;
        pintarGrupo(g);
        pintarResumo();
        erro(tr('erro_abrir'));
      }
    });
  }
  // Enquanto o cliente nao mexeu nas opcoes de uma peca que completa, elas
  // acompanham a principal.
  function seguirAncora() {
    var va = varDoGrupo(ancora());
    if (!va) return;
    grupos.forEach(function (g) {
      if (g.medida) {
        // a medida muda com a cama; o elevatorio sai se a cama deixou de ser sommier
        if (g.esc && !eSommier() && cartao(g, g.esc.op) && cartao(g, g.esc.op).hasAttribute('data-so-sommier')) g.esc = null;
        pintarGrupo(g);
        return;
      }
      if (g.papel === 'ancora' || !g.esc || !g.esc.p || g.esc.mexeu) return;
      g.esc.vals = iniciais(g.esc.p, va.o);
      pintarGrupo(g);
    });
  }

  /* ---- pintar ------------------------------------------------------------ */

  function pintarGrupo(g) {
    var e = g.esc;
    g.el.querySelectorAll('[data-mm-op]').forEach(function (b) {
      if (b.hasAttribute('data-so-sommier')) {
        b.disabled = !eSommier();
        b.title = b.disabled ? tr('para_sommier') : '';
      }
      var sel = !!e && b.getAttribute('data-h') === e.op;
      b.setAttribute('aria-pressed', sel ? 'true' : 'false');
      var im = b.querySelector('[data-mm-op-img]');
      if (!im) return;
      if (!im.hasAttribute('data-orig')) im.setAttribute('data-orig', im.getAttribute('src'));
      // a imagem do escolhido segue a versao e o acabamento escolhidos
      var v = sel ? varDoGrupo(g) : null;
      var src = v && v.img ? img(v.img, 400) : (sel && e.p && e.p.img ? img(e.p.img, 400) : im.getAttribute('data-orig'));
      if (im.getAttribute('src') !== src) im.setAttribute('src', src);
    });
    var det = g.el.querySelector('[data-mm-det]');
    if (!e) { det.hidden = true; det.innerHTML = ''; return; }
    var bt = cartao(g, e.op);
    var vs = bt ? versoesDe(bt) : [];
    var html = '';
    if (vs.length > 1) {
      html += '<div class="mm-eixo" role="group" aria-label="' + esc(tr('versao')) + '"><p class="mm-eixo__r">' + esc(tr('versao')) + '</p><div class="mm-pills">' +
        vs.map(function (x) {
          return '<button type="button" class="mm-pill" data-mm-versao="' + esc(x.h) + '" aria-pressed="' + (x.h === e.h) + '">' + esc(x.n) + '</button>';
        }).join('') + '</div></div>';
    }
    if (!e.p) {
      html += '<p class="mm-carrega">' + esc(tr('a_abrir')) + '</p>';
    } else if (g.medida) {
      var vm = varDoGrupo(g), m = medida();
      html += '<p class="mm-det__p">' + (vm
        ? tr('na_medida', { v: esc(vm.o.join(' · ')), p: '<b>' + moeda(vm.c) + '</b>' })
        : esc(m ? tr('nao_ha_medida') : tr('segue_medida'))) + '</p>';
    } else {
      var disp = disponiveis(e.p);
      e.p.opcoes.forEach(function (o, i) {
        if (o.valores.length < 2 || o.nome === 'Title') return;
        html += '<div class="mm-eixo" role="group" aria-label="' + esc(o.nome) + '"><p class="mm-eixo__r">' + esc(o.nome) + '</p><div class="mm-pills">' +
          o.valores.map(function (val) {
            var ha = disp.some(function (v) { return v.o[i] === val; });
            return '<button type="button" class="mm-pill" data-mm-eixo="' + i + '" data-valor="' + esc(val) + '" aria-pressed="' + (e.vals[i] === val) + '"' + (ha ? '' : ' disabled') + '>' + esc(val) + '</button>';
          }).join('') + '</div></div>';
      });
      var v = varDoGrupo(g);
      if (v) {
        html += '<p class="mm-det__p">' + (g.q > 1 ? g.q + ' × ' + moeda(v.c) + ' = <b>' + moeda(v.c * g.q) + '</b>' : '<b>' + moeda(v.c) + '</b>') +
          ' <a class="mm-det__ver" href="' + raizLoja + 'products/' + encodeURIComponent(e.h) + '?variant=' + v.id + '">' + esc(tr('ver_peca')) + '</a></p>';
      }
    }
    if (g.papel !== 'ancora') html += '<button type="button" class="mm-tirar" data-mm-tirar>' + esc(tr('sem', { x: g.um })) + '</button>';
    det.innerHTML = html;
    det.hidden = false;
  }

  function linhas() {
    var ls = [];
    grupos.forEach(function (g, n) {
      var v = varDoGrupo(g);
      if (!v || !v.ok) return;
      ls.push({ k: 'g' + n, cat: g.cat, c: v.c, q: g.q, g: g, v: v });
    });
    return ls;
  }

  // O que falta para haver pack, dito pela peca que falta.
  var FALTA = { quarto: tr('falta_quarto'), sala: tr('falta_sala'), arrumacao: tr('falta_arrumacao') };

  var ultimo = null;
  function pintarResumo() {
    var corpo = raiz.querySelector('[data-mm-resumo-corpo]');
    var ls = linhas();
    var aberto = grupos.some(function (g) { return g.esc && !g.esc.p; });
    var r = packsDe(ls);
    var bruto = ls.reduce(function (s, l) { return s + l.c * l.q; }, 0);
    var total = bruto - r.menos;
    var temAncora = ls.some(function (l) { return l.g.papel === 'ancora'; });
    var pode = temAncora && r.packs.length > 0 && !aberto;
    ultimo = { ls: ls, total: total, pode: pode };

    if (!ls.length) {
      corpo.innerHTML = '<p class="mm-vazio">' + esc(aberto ? tr('a_abrir') : tr('escolha_principal')) + '</p>';
    } else {
      var html = '<ul class="mm-linhas">' + ls.map(function (l) {
        var p = l.g.esc.p;
        var det = p.opcoes.map(function (o, i) { return o.valores.length > 1 && o.nome !== 'Title' ? l.v.o[i] : null; }).filter(Boolean).join(' · ');
        return '<li class="mm-linha">' +
          '<span class="mm-linha__img">' + (l.v.img || p.img ? '<img src="' + esc(img(l.v.img || p.img, 160)) + '" alt="" width="56" height="56" loading="lazy">' : '') + '</span>' +
          '<span class="mm-linha__t"><b>' + (l.q > 1 ? l.q + ' × ' : '') + esc(p.t) + '</b>' + (det ? '<small>' + esc(det) + '</small>' : '') + '</span>' +
          '<span class="mm-linha__c">' + moeda(l.c * l.q) + '</span></li>';
      }).join('') + '</ul>';
      html += '<dl class="mm-contas">';
      if (r.packs.length) {
        html += '<div><dt>' + esc(tr('soma')) + '</dt><dd>' + moeda(bruto) + '</dd></div>';
        r.packs.forEach(function (pk) {
          html += '<div class="mm-contas__pack"><dt>' + esc(tr('pack_menos', { pack: pk.nome, pct: pk.pct })) + '</dt><dd>−' + moeda(pk.menos) + '</dd></div>';
        });
      }
      html += '<div class="mm-contas__total"><dt>' + esc(tr('total')) + '</dt><dd>' + moeda(total) + '</dd></div></dl>';
      if (r.packs.length) {
        html += '<p class="mm-nota">' + esc(tr('desconto_sozinho')) + '</p>';
      } else if (temAncora) {
        html += '<p class="mm-nota mm-nota--falta">' + esc(FALTA[salaActual]) + '</p>';
      }
      corpo.innerHTML = html;
    }
    raiz.querySelectorAll('[data-mm-comprar]').forEach(function (b) { b.disabled = !pode || a_comprar; });
    var barra = raiz.querySelector('[data-mm-barra]');
    if (barra) {
      barra.querySelector('[data-mm-barra-total]').textContent = ls.length ? moeda(total) : '';
      barra.querySelector('[data-mm-barra-sel]').textContent = r.packs.length
        ? r.packs.map(function (p) { return tr('pack_menos', { pack: p.nome, pct: p.pct }); }).join(' + ')
        : (temAncora ? tr('falta_peca') : '');
      mostrarBarra();
    }
  }

  function pintarTudo() {
    grupos.forEach(pintarGrupo);
    pintarResumo();
  }

  /* ---- a barra do telemovel ---------------------------------------------- */

  // No telemovel o resumo fica no fim da pagina; enquanto nao se ve, o total e
  // o botao vao numa barra em baixo. Some quando o resumo entra no ecra.
  var resumoVisivel = false;
  function mostrarBarra() {
    var barra = raiz.querySelector('[data-mm-barra]');
    var ha = ultimo && ultimo.ls.length > 0;
    barra.hidden = !ha || resumoVisivel;
  }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      resumoVisivel = es[0].isIntersecting;
      mostrarBarra();
    }, { threshold: 0.35 }).observe(raiz.querySelector('[data-mm-resumo]'));
  }

  /* ---- comprar ----------------------------------------------------------- */

  var a_comprar = false;
  function erro(t) {
    raiz.querySelectorAll('[data-mm-erro]').forEach(function (el) { el.textContent = t || ''; el.hidden = !t; });
  }
  function comprar() {
    if (!ultimo || !ultimo.pode || a_comprar) return;
    a_comprar = true;
    erro('');
    raiz.querySelectorAll('[data-mm-comprar]').forEach(function (b) { b.disabled = true; });
    var items = ultimo.ls.map(function (l) { return { id: l.v.id, quantity: l.q }; });
    // O estrado e o colchao levam as propriedades que o carrinho agrupa com a
    // cama (_bundle_group/_bundle_role/Conjunto), as mesmas da ficha.
    var comCama = ultimo.ls.filter(function (l) { return l.g.medida; });
    if (comCama.length) {
      var grupo = 'bg-' + Date.now() + '-' + Math.random().toString(36).slice(2, 7);
      var cama = ultimo.ls.filter(function (l) { return l.g.papel === 'ancora'; })[0];
      ultimo.ls.forEach(function (l, n) {
        var papel = l === cama ? 'bed' : (l.g.medida ? (l.g.cat === 'estrados' ? 'estrado' : 'colchao') : null);
        if (papel) items[n].properties = { '_bundle_group': grupo, '_bundle_role': papel, 'Conjunto': cama.g.esc.p.t };
      });
    }
    fetch(raizLoja + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, j: j }; });
    }).then(function (res) {
      if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || '');
      window.location.href = raizLoja + 'cart';
    }).catch(function (err) {
      a_comprar = false;
      pintarResumo();
      erro(tr('erro_carrinho') + (err && err.message ? ' ' + err.message : ''));
    });
  }

  /* ---- toques ------------------------------------------------------------ */

  function grupoDe(el) {
    var sec = el.closest('[data-mm-grupo]');
    for (var i = 0; i < grupos.length; i++) if (grupos[i].el === sec) return grupos[i];
    return null;
  }
  raiz.addEventListener('click', function (ev) {
    var b = ev.target.closest('button');
    if (!b || b.disabled || !raiz.contains(b)) return;
    if (b.hasAttribute('data-mm-sala-bt')) { mudarSala(b.getAttribute('data-mm-sala-bt')); return; }
    if (b.hasAttribute('data-mm-comprar')) { comprar(); return; }
    var g = grupoDe(b);
    if (!g) return;
    erro('');
    if (b.hasAttribute('data-mm-op')) {
      var h = b.getAttribute('data-h');
      if (g.esc && g.esc.op === h) {
        // tocar outra vez no escolhido retira-o (a principal fica)
        if (g.papel !== 'ancora') { g.esc = null; pintarGrupo(g); pintarResumo(); }
        return;
      }
      escolher(g, h, h);
    } else if (b.hasAttribute('data-mm-versao')) {
      var hv = b.getAttribute('data-mm-versao');
      if (g.esc && g.esc.h !== hv) escolher(g, g.esc.op, hv);
    } else if (b.hasAttribute('data-mm-eixo')) {
      if (!g.esc || !g.esc.p) return;
      var i = +b.getAttribute('data-mm-eixo');
      var vals = g.esc.vals.slice();
      vals[i] = b.getAttribute('data-valor');
      g.esc.vals = perto(g.esc.p, vals, i);
      if (g.papel !== 'ancora') g.esc.mexeu = true;
      pintarGrupo(g);
      if (g.papel === 'ancora') seguirAncora();
      pintarResumo();
    } else if (b.hasAttribute('data-mm-tirar')) {
      g.esc = null;
      pintarGrupo(g);
      pintarResumo();
    }
  });

  /* ---- arranque ---------------------------------------------------------- */

  var q = new URLSearchParams(location.search);
  var salaQ = q.get('divisao');
  mudarSala(salaQ && raiz.querySelector('[data-mm-sala="' + salaQ + '"]') ? salaQ : 'quarto');
  var pecaQ = q.get('peca');
  if (pecaQ) {
    var a = ancora();
    var bts = a ? a.el.querySelectorAll('[data-mm-op]') : [];
    for (var k = 0; k < bts.length; k++) {
      var op = bts[k].getAttribute('data-h');
      if (op === pecaQ || versoesDe(bts[k]).some(function (x) { return x.h === pecaQ; })) {
        escolher(a, op, pecaQ);
        break;
      }
    }
  }
})();
